import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/ProductFeaturesService.ts";
import {useProductFeaturesSelection} from "../hooks/useProductFeaturesSelection.ts";
import {productFeaturesQueryKeys} from "../hooks/useProductFeatures.ts";
import {notifyError, notifySuccess} from '../../../components/ServiceNotifications';

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useProductFeaturesSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: () => Promise.all(selectedRecords.map(record => deleteRecord(record.id))),
        // The selection is cleared only once every delete landed; a failure keeps it, so
        // the operator can see what was meant to go and retry.
        onSuccess: () => {
            clearSelection();
            notifySuccess(I18n.get('Product Features deleted'));
            queryClient.invalidateQueries({queryKey: productFeaturesQueryKeys.all});
        },
        onError: (e) => {
            notifyError(e);
            queryClient.invalidateQueries({queryKey: productFeaturesQueryKeys.all});
        },
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={() => mutation.mutate()}
        />
    );
};
